import { Button, ButtonsGroup, InputPhone, InputSelect, InputText, Select } from "#/atoms";
import { FC, memo, useCallback } from "react";
import { useInput, useInputSelect, useSelect } from "@/hooks";

import { CONTACT_TYPE } from "@/types";
import { ContactModalProps } from "./Contact.interface";
import { DESKTOP_SPACING } from "@/theme";
import { Modal } from "#/molecules";
import { StyledContactModal } from "./Contact.styled";

const getContactType = (type?: CONTACT_TYPE) => {
  switch (type) {
    case CONTACT_TYPE.AGENT: {
      return '3';
    }
    case CONTACT_TYPE.TENANT: {
      return '1';
    }
    case CONTACT_TYPE.VENDOR:
    default: {
      return '0';
    }
  }
}

const Contact: FC<ContactModalProps> = ({ contact, hideType, onClose, onAddNew, onEdit, type }) => {
  const contactType = useSelect(getContactType(contact?.type));
  const name = useInput(contact?.name, [(v) => [v.length > 0, 'Name is required']]);
  const email = useInput(contact?.email, [(v) => [v.length > 0, 'Email is required']]);
  const phone1 = useInput(contact?.phone1, [(v) => [v.length > 0, 'Phone is required']]);
  const phone2 = useInput(contact?.phone2);
  const sendInvoice = useInputSelect('', contact?.sendInvoice);

  const handleSubmit = useCallback(() => {

    // name.validate();
    // email.validate();
    // phone1.validate();
    // const isValid = name.error === null && email.error === null && phone1.error === null;

    let isValid = true;

    if (name.value.length <= 0) {
      name.setError('Name is required');
      isValid = false;
    } else {
      name.setError(null);
    }

    if (email.value.length > 0 && !email.value.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)) {
      email.setError('Email is not valid');
      isValid = false;
    } else {
      email.setError(null);
    }

    if (phone1.value.length <= 0) {
      phone1.setError('Phone1 is required');
      isValid = false;
    } else {
      phone1.setError(null);
    }

    if (!isValid) {
      return;
    }

    if (type === 'create') {
      onAddNew({
        contactId: new Date().getTime().toString(),
        customerId: '',
        email: email.value,
        name: name.value,
        phone1: phone1.value,
        phone2: phone2.value,
        sendInvoice: sendInvoice.checked,
      });
    } else if (contact && type === 'edit') {
      onEdit({
        contactId: contact.contactId,
        customerId: contact.customerId,
        email: email.value,
        name: name.value,
        phone1: phone1.value,
        phone2: phone2.value,
        sendInvoice: sendInvoice.checked
      });
    }
  }, [contactType, name, email, phone1, phone2]);

  const title = type === 'create' ? 'Create New Contact' : 'Edit Contact'
  const buttonLabel = type === 'create' ? 'Create' : 'Edit'

  return (
    <Modal onClose={onClose} title={title}>
      <StyledContactModal>
        {!hideType && <Select
          label="Contact Type"
          onChange={contactType.onChange}
          options={[
            { id: '0', label: 'Vendor' },
            { id: '1', label: 'Tenant' },
            { id: '2', label: 'Agent' },
          ]}
          selected={contactType.value}
        /> }
        <InputText type="text" label="Contact Name" value={name.value} onChange={name.onChange} errorMessage={name.error || ''} state={name.error ? 'error' : 'idle'} />
        <InputText type="email" label="E-mail Address" value={email.value} onChange={email.onChange} errorMessage={email.error || ''} state={email.error ? 'error' : 'idle'}  />
        <InputPhone type="tel" label="Phone Number 1" value={phone1.value} onChange={phone1.onChange} errorMessage={phone1.error || ''} state={phone1.error ? 'error' : 'idle'}  />
        <InputPhone type="tel" label="Phone Number 2" value={phone2.value} onChange={phone2.onChange} />
        <InputSelect type="checkbox" checked={sendInvoice.checked} label="Send invoices to contact" value={sendInvoice.value} onChangeValue={sendInvoice.onChange} />
        <ButtonsGroup fullWidth margin={`${DESKTOP_SPACING.EL}px 0 0`}>
          <Button onClick={handleSubmit}>{buttonLabel}</Button>
        </ButtonsGroup>
      </StyledContactModal>
    </Modal>
  );
};

export default memo(Contact);
